import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { doughnutChartOptions } from "~/misc/charts";
import { initTreeStats } from "~/misc/stats";

export default class extends Controller {
  connect() {
    console.log('initTeachingGroupsStats');
    initTreeStats();

    const doughnut_data = $('#toJs').data('doughnut');
    if (doughnut_data) {
      const ctx = $('#doughnut')[0] as HTMLCanvasElement;
      const options = doughnutChartOptions;
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: doughnut_data.datasets,
          labels: doughnut_data.labels
        },
        options: options
      });
    }
  }
}

